import { createContext, useContext } from "react";

import type { DeploymentProgress } from "../deploy/progress.js";
import type { UniswapDeployment } from "@gotts.ai/devenv";
import type { Chain, PublicClient, TestClient, WalletClient } from "viem";

/** Context value for Tevm clients and deployment state. */
export interface TevmContextValue {
  publicClient: PublicClient;
  walletClient: WalletClient;
  testClient: TestClient;
  chain: Chain;
  deployment: UniswapDeployment | null;
  deploymentProgress: DeploymentProgress | null;
}

export const TevmContext = createContext<TevmContextValue | null>(null);

/** Hook to access Tevm clients and deployment state. */
export function useTevmContext(): TevmContextValue | null {
  return useContext(TevmContext);
}

/** Hook that throws if Tevm is not initialized. */
export function useRequiredTevmContext(): TevmContextValue {
  const ctx = useContext(TevmContext);
  if (!ctx) {
    throw new Error(
      "useTevmContext must be used within a TevmContext.Provider",
    );
  }
  return ctx;
}
